const elevation = {
  shadow0: 'none',
  shadow1: '0 2px 4px rgba(0,0,0,0.16), 0px 1px rgba(0,0,0,0.18)',
  shadow2: '0 4px 8px rgba(0,0,0,0.16), 0px 1px rgba(0,0,0,0.16)',
  shadow3: '0 8px 16px rgba(0,0,0,0.16), 0px 1px rgba(0,0,0,0.14)',
  shadow4: '0 24px 48px rgba(0,0,0,0.2), 0px 1px rgba(0,0,0,0.12)',
};

export default elevation;
